// extracted by mini-css-extract-plugin
module.exports = {"productCard":"ProductCard_productCard__1Axwv","content":"ProductCard_content__1lGWC","arrow":"ProductCard_arrow__1kj_t"};